
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Select from "@/components/form/Select.vue";
import AsnModule from "@/store/modules/asn";
import { SystemModule } from "@/store/modules";
import BarcodeCompanyModule from "@/store/modules/barcodeSystem/barcodeCompany";
import BarcodeManufacturerModule from "@/store/modules/barcodeSystem/barcodeManufacturer";


import { getModule } from "vuex-module-decorators";
import { AsnLevel } from "@/models/api/asn/asn";
import { AsnFormula } from "@/models/api/asn/formula";

import _ from "lodash";
import { KeyValuePair, Lookup } from "@/models/api/asn/lookup";

const asnModule = getModule(AsnModule);
const sysModule = getModule(SystemModule);
const bcCompanyModule = getModule(BarcodeCompanyModule);
const bcManufacturerModule = getModule(BarcodeManufacturerModule);

interface ValueOption {
  label: string;
  value: string;
}

@Component({
    components: {
    Select
  }
})
export default class LookupLine extends Vue {
    @Prop({ default: null })
    LookupLine: Lookup;

    @Prop({ default: []})
    Mappable: string[];

    MapTo: string = "";
    KVP: Array<KeyValuePair> = [];
    
    @Watch("MapTo")
    async selectedMapChanged(newValue){
        if (newValue !== ''){
            await this.onLookupUpdated();
        }
    }

    @Watch("KVP")
    selectedKVPChanged(newValue){
        if (newValue !== ''){
            this.onLookupUpdated();
        }
    }
    
    async onAddKVP(){
        this.KVP.push({ key: '', value: '' });
        await this.onLookupUpdated();
    }

    async onRemoveKVP(item){
        this.KVP = this.KVP.filter(x => x != item);
        await this.onLookupUpdated();
    }

    async onLookupUpdated(){
        this.$emit('lookup-updated', 
        {   
            id: this.LookupLine.id, 
            map: this.MapTo, 
            kvp: this.KVP
        });
    }

    async onRemoveLookup(){
        this.$emit('lookup-removed', this.LookupLine);
    }

    async created(){
        this.MapTo = this.LookupLine.map;
        this.KVP = this.LookupLine.kvp;
    }
}

